import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';

// Global styles
import './styles.css';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Add global CSS
const style = document.createElement('style');
style.textContent = `
  @import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@300;400;500;600;700&display=swap');

  * {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
  }

  body {
    font-family: 'Montserrat', sans-serif;
    background-color: #000;
    color: #fff;
    overflow-x: hidden;
    line-height: 1.6;
  }

  .site-ambient-glow {
    position: fixed;
    inset: 0;
    z-index: 500;
    pointer-events: none;
    background:
      radial-gradient(circle at 12% 8%, rgba(108, 99, 255, 0.34), transparent 44%),
      radial-gradient(circle at 88% 92%, rgba(14, 165, 233, 0.24), transparent 42%),
      radial-gradient(circle at 50% 115%, rgba(74, 0, 224, 0.28), transparent 52%),
      radial-gradient(circle at 72% 18%, rgba(142, 46, 226, 0.12), transparent 38%);
    animation: siteAmbientGlowPulse 14s ease-in-out infinite;
  }

  @keyframes siteAmbientGlowPulse {
    0%,
    100% {
      opacity: 0.82;
    }
    50% {
      opacity: 1;
    }
  }

  @media (prefers-reduced-motion: reduce) {
    .site-ambient-glow {
      animation: none;
      opacity: 0.9;
    }
  }

  .password-gate {
    min-height: 100vh;
    display: flex;
    align-items: stretch;
    justify-content: stretch;
    padding: 0;
    position: fixed;
    inset: 0;
    z-index: 10000;
    background: #000;
    opacity: 1;
    transform: translateY(0);
    transition: opacity 0.3s ease, transform 0.3s ease;
  }

  .password-gate.gate-exit {
    opacity: 0;
    transform: translateY(-18px);
    pointer-events: none;
  }

  .password-card {
    width: min(520px, 100%);
    padding: 3rem;
    border-radius: 24px;
    background: rgba(15, 15, 15, 0.8);
    border: 1px solid rgba(255, 255, 255, 0.08);
    box-shadow: 0 30px 60px rgba(0, 0, 0, 0.45);
    backdrop-filter: blur(18px);
    -webkit-backdrop-filter: blur(18px);
    position: relative;
    overflow: hidden;
    animation: luxuryFloat 10s ease-in-out infinite;
  }

  .password-card::before {
    content: '';
    position: absolute;
    inset: 0;
    background: linear-gradient(120deg, transparent 20%, rgba(255, 255, 255, 0.08), transparent 60%);
    transform: translateX(-120%);
    animation: luxurySheen 8s ease-in-out infinite;
    pointer-events: none;
  }

  .password-badge {
    display: inline-flex;
    padding: 0.35rem 0.9rem;
    border-radius: 999px;
    font-size: 0.7rem;
    letter-spacing: 2px;
    text-transform: uppercase;
    color: rgba(255, 255, 255, 0.75);
    border: 1px solid rgba(255, 255, 255, 0.2);
    margin-bottom: 1.5rem;
  }

  .password-title {
    font-size: 2.2rem;
    margin-bottom: 0.75rem;
    font-weight: 600;
  }

  .password-subtitle {
    font-size: 1rem;
    color: rgba(255, 255, 255, 0.7);
    margin-bottom: 2.5rem;
  }

  .password-form {
    display: flex;
    flex-direction: column;
    gap: 1rem;
  }

  .password-label {
    font-size: 0.85rem;
    text-transform: uppercase;
    letter-spacing: 2px;
    color: rgba(255, 255, 255, 0.65);
  }

  .password-input {
    background: rgba(255, 255, 255, 0.08);
    border: 1px solid rgba(255, 255, 255, 0.15);
    border-radius: 12px;
    padding: 0.85rem 1rem;
    color: #fff;
    font-size: 1rem;
    outline: none;
    transition: border-color 0.3s ease, box-shadow 0.3s ease;
  }

  .password-input:focus {
    border-color: rgba(108, 99, 255, 0.6);
    box-shadow: 0 0 0 3px rgba(108, 99, 255, 0.2);
  }

  .password-error {
    color: #fca5a5;
    font-size: 0.85rem;
  }

  .password-button {
    margin-top: 0.5rem;
    padding: 0.9rem 1.5rem;
    border-radius: 999px;
    border: none;
    background: linear-gradient(120deg, #6c63ff, #0ea5e9);
    color: #fff;
    font-weight: 600;
    letter-spacing: 1px;
    cursor: pointer;
    transition: transform 0.2s ease, box-shadow 0.3s ease;
  }

  .password-button:hover {
    transform: translateY(-2px);
    box-shadow: 0 12px 30px rgba(108, 99, 255, 0.35);
  }

  .verification-card {
    overflow: visible;
  }

  .verification-gate-root {
    position: relative;
    width: 100%;
    min-height: 100vh;
    isolation: isolate;
  }

  .verify-gate-bg {
    position: fixed;
    inset: 0;
    z-index: 0;
    background: linear-gradient(135deg, #8e2de2, #4a00e0);
    overflow: hidden;
  }

  .verify-gate-bg-video {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  .verify-gate-bg-vignette {
    position: absolute;
    inset: 0;
    background:
      radial-gradient(circle at 12% 8%, rgba(108, 99, 255, 0.34), transparent 44%),
      radial-gradient(circle at 88% 92%, rgba(14, 165, 233, 0.24), transparent 42%),
      radial-gradient(circle at 50% 115%, rgba(74, 0, 224, 0.28), transparent 52%);
    pointer-events: none;
  }

  .verify-gate-bg-overlay {
    position: absolute;
    inset: 0;
    background: rgba(0, 0, 0, 0.38);
    pointer-events: none;
  }

  .verification-shell {
    width: 100%;
    min-height: 100vh;
    position: relative;
    z-index: 1;
  }

  .verification-shell--puzzle {
    overflow: hidden;
  }

  .verification-shell--password {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 2rem;
  }

  .verify-overlay-header {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    z-index: 3;
    padding: 2rem 2.5rem 1rem;
    pointer-events: none;
    text-align: center;
  }

  .verify-overlay-title {
    font-size: clamp(1.75rem, 4vw, 2.5rem);
    margin-bottom: 0.5rem;
  }

  .verify-overlay-subtitle {
    margin-bottom: 0;
    font-size: clamp(0.9rem, 2vw, 1.05rem);
  }

  .verify-primary-hint {
    position: fixed;
    bottom: 14%;
    left: calc(2.5rem + 3in);
    z-index: 4;
    max-width: 28rem;
    margin: 0;
    padding: 0.5rem 0;
    font-size: clamp(1.15rem, 2.8vw, 1.85rem);
    font-weight: 800;
    font-style: italic;
    line-height: 1.25;
    letter-spacing: 0.06em;
    text-transform: uppercase;
    color: #fff;
    transform: rotate(-45deg);
    transform-origin: left bottom;
    pointer-events: none;
    text-shadow:
      0 0 32px rgba(108, 99, 255, 0.85),
      0 0 64px rgba(14, 165, 233, 0.45),
      0 2px 4px rgba(0, 0, 0, 0.65);
    filter: drop-shadow(0 0 12px rgba(108, 99, 255, 0.5));
  }

  @media (max-width: 480px) {
    .verify-primary-hint {
      left: calc(1.25rem + 3in);
      bottom: 18%;
      max-width: 16rem;
      font-size: 1rem;
      letter-spacing: 0.04em;
    }
  }

  .verify-fallback-wrap {
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 100vh;
    padding: 2rem;
  }

  .verification-subtitle {
    margin-bottom: 1.5rem;
  }

  .verify-play-area {
    position: relative;
    width: 100%;
    touch-action: none;
  }

  .verify-play-area--fullscreen {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    min-height: 100vh;
    border: none;
    border-radius: 0;
    background: transparent;
    z-index: 1;
    cursor: default;
  }

  .verify-sphere {
    position: absolute;
    left: 0;
    top: 0;
    padding: 0;
    border: none;
    border-radius: 50%;
    cursor: default;
    z-index: 2;
    overflow: hidden;
    background: conic-gradient(
      from 45deg,
      #e74c3c 0deg 90deg,
      #f1c40f 90deg 180deg,
      #3498db 180deg 270deg,
      #2ecc71 270deg 360deg
    );
    box-shadow:
      inset -10px -14px 28px rgba(0, 0, 0, 0.4),
      inset 8px 8px 18px rgba(255, 255, 255, 0.28),
      0 10px 28px rgba(0, 0, 0, 0.45);
    transition: filter 0.12s ease, box-shadow 0.12s ease;
  }

  .verify-sphere-shine {
    position: absolute;
    top: 14%;
    left: 18%;
    width: 28%;
    height: 22%;
    border-radius: 50%;
    background: radial-gradient(circle, rgba(255, 255, 255, 0.75), transparent 70%);
    pointer-events: none;
  }

  .verify-sphere-label {
    position: absolute;
    inset: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 0.72rem;
    font-weight: 700;
    letter-spacing: 1px;
    text-transform: uppercase;
    color: rgba(255, 255, 255, 0.95);
    text-shadow: 0 1px 4px rgba(0, 0, 0, 0.55);
    pointer-events: none;
  }

  .verify-sphere-check {
    position: absolute;
    inset: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1.75rem;
    font-weight: 700;
    color: #fff;
    text-shadow: 0 2px 8px rgba(0, 0, 0, 0.45);
    pointer-events: none;
  }

  .verify-sphere--drifting {
    will-change: transform;
  }

  .verify-sphere--waiting {
    animation: verifySphereWaiting 2.2s ease-in-out infinite;
    cursor: pointer;
  }

  @keyframes verifySphereWaiting {
    0%,
    100% {
      filter: brightness(1);
      box-shadow:
        inset -10px -14px 28px rgba(0, 0, 0, 0.4),
        inset 8px 8px 18px rgba(255, 255, 255, 0.28),
        0 10px 28px rgba(0, 0, 0, 0.45);
    }
    50% {
      filter: brightness(1.1);
      box-shadow:
        inset -10px -14px 28px rgba(0, 0, 0, 0.4),
        inset 8px 8px 18px rgba(255, 255, 255, 0.28),
        0 0 28px rgba(108, 99, 255, 0.45);
    }
  }

  .verify-sphere--pop {
    transition: none;
  }

  .verify-sphere--catchable {
    cursor: pointer;
    animation: verifySpherePulse 1.2s ease-in-out infinite;
  }

  .verify-sphere--catchable:hover {
    filter: brightness(1.12);
  }

  .verify-sphere--success {
    background: conic-gradient(
      from 45deg,
      #22c55e 0deg 90deg,
      #0ea5e9 90deg 180deg,
      #6c63ff 180deg 270deg,
      #22c55e 270deg 360deg
    );
    cursor: default;
    animation: none;
  }

  .verify-sphere--dodge {
    filter: brightness(1.2) saturate(1.15);
    box-shadow:
      inset -10px -14px 28px rgba(0, 0, 0, 0.4),
      inset 8px 8px 18px rgba(255, 255, 255, 0.28),
      0 0 36px rgba(248, 113, 113, 0.65);
  }

  @keyframes verifySpherePulse {
    0%,
    100% {
      filter: brightness(1);
      box-shadow:
        inset -10px -14px 28px rgba(0, 0, 0, 0.4),
        inset 8px 8px 18px rgba(255, 255, 255, 0.28),
        0 10px 28px rgba(0, 0, 0, 0.45);
    }
    50% {
      filter: brightness(1.14);
      box-shadow:
        inset -10px -14px 28px rgba(0, 0, 0, 0.4),
        inset 8px 8px 18px rgba(255, 255, 255, 0.28),
        0 0 36px rgba(108, 99, 255, 0.55);
    }
  }

  .verify-chip {
    position: absolute;
    left: 0;
    top: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0;
    border-radius: 999px;
    border: 1px solid rgba(255, 255, 255, 0.25);
    background: linear-gradient(120deg, #6c63ff, #0ea5e9);
    color: #fff;
    font-weight: 600;
    font-size: 0.9rem;
    letter-spacing: 0.5px;
    cursor: pointer;
    z-index: 2;
    box-shadow: 0 8px 24px rgba(108, 99, 255, 0.35);
    transition: box-shadow 0.2s ease, filter 0.2s ease;
  }

  .verify-chip:hover:not(:disabled) {
    box-shadow: 0 12px 30px rgba(108, 99, 255, 0.5);
    filter: brightness(1.05);
  }

  .verify-chip--success {
    background: linear-gradient(120deg, #22c55e, #0ea5e9);
    cursor: default;
  }

  .verify-chip--dodge {
    filter: brightness(1.35) saturate(1.2);
    box-shadow: 0 0 28px rgba(248, 113, 113, 0.55);
  }

  .verify-hint {
    font-size: 0.85rem;
    color: rgba(255, 255, 255, 0.55);
    margin-top: 0.25rem;
    margin-bottom: 0;
  }

  .verify-hint--overlay {
    position: absolute;
    bottom: 1.5rem;
    left: 50%;
    transform: translateX(-50%);
    z-index: 3;
    padding: 0.6rem 1.25rem;
    max-width: min(92vw, 520px);
    text-align: center;
    line-height: 1.45;
    border-radius: 999px;
    background: rgba(0, 0, 0, 0.55);
    border: 1px solid rgba(108, 99, 255, 0.35);
    backdrop-filter: blur(12px);
    -webkit-backdrop-filter: blur(12px);
    pointer-events: none;
  }

  .verify-fallback-button {
    width: 100%;
  }

  .main-stage {
    opacity: 0;
    transform: translateY(16px);
    transition: opacity 0.35s ease, transform 0.35s ease;
    pointer-events: none;
    visibility: hidden;
  }

  .main-stage--locked {
    position: fixed;
    inset: 0;
    overflow: hidden;
    max-height: 100vh;
    z-index: 0;
  }

  .main-stage--visible {
    opacity: 1;
    transform: translateY(0);
    pointer-events: auto;
    visibility: visible;
    position: relative;
    inset: auto;
    overflow: visible;
    max-height: none;
    z-index: auto;
  }

  .app-unlocked .main-stage {
    transition-delay: 0.05s;
  }

  @keyframes luxuryFloat {
    0% {
      transform: translateY(0);
    }
    50% {
      transform: translateY(-6px);
    }
    100% {
      transform: translateY(0);
    }
  }

  @keyframes luxurySheen {
    0% {
      transform: translateX(-120%);
    }
    45% {
      transform: translateX(120%);
    }
    100% {
      transform: translateX(120%);
    }
  }

  .app-container {
    position: relative;
    width: 100%;
    min-height: 100vh;
  }

  /* Navbar Styles */
  .navbar {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    z-index: 1000;
    padding: 1.5rem 0;
    transition: background-color 0.3s ease;
    background-color: rgba(0, 0, 0, 0.7);
    backdrop-filter: blur(10px);
    -webkit-backdrop-filter: blur(10px);
  }

  .nav-container {
    width: 90%;
    max-width: 1400px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .nav-logo {
    font-size: 1.5rem;
    font-weight: 600;
    color: #fff;
    text-decoration: none;
    letter-spacing: 1px;
  }

  .nav-links {
    display: flex;
    gap: 2rem;
  }

  .nav-link {
    color: #fff;
    text-decoration: none;
    font-size: 0.85rem;
    font-weight: 500;
    letter-spacing: 1px;
    transition: opacity 0.3s ease;
  }

  .nav-link:hover {
    opacity: 0.8;
  }

  .cart-link {
    position: relative;
  }

  .cart-count {
    display: inline-block;
    margin-left: 5px;
  }

  /* Video Background Styles */
  .video-scenery,
  .video-background {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100vh;
    overflow: hidden;
    z-index: -1;
  }

  .scenery-video,
  .background-video {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  .video-overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.3);
  }

  /* Main Content Styles */
  .main-content {
    width: 100%;
    height: 100vh;
    display: flex;
    flex-direction: column;
    justify-content: center;
    position: relative;
    opacity: 0;
    transform: translateY(20px);
    transition: opacity 0.8s ease, transform 0.8s ease;
  }

  .main-content.loaded {
    opacity: 1;
    transform: translateY(0);
  }
  
  .main-content.video-fallback .video-scenery,
  .main-content.video-fallback .video-background {
    background: linear-gradient(135deg, #8e2de2, #4a00e0);
  }
  
  /* Always have a background even while video is loading */
  .video-scenery,
  .video-background {
    background: linear-gradient(135deg, #8e2de2, #4a00e0);
  }

  .content-wrapper {
    width: 90%;
    max-width: 1400px;
    margin: 0 auto;
    padding: 0 2rem;
    position: relative;
    z-index: 2;
  }

  .hero-text {
    margin-bottom: 2rem;
  }
  
  .brand-label {
    display: inline-block;
    font-size: 0.9rem;
    font-weight: 500;
    letter-spacing: 2px;
    text-transform: uppercase;
    color: rgba(255, 255, 255, 0.8);
    margin-bottom: 1rem;
    border: 1px solid rgba(255, 255, 255, 0.3);
    padding: 0.4rem 1rem;
    border-radius: 30px;
  }

  .big-text {
    font-size: 4.5rem;
    font-weight: 700;
    margin-bottom: 1rem;
    line-height: 1.1;
    text-transform: uppercase;
  }

  .subtitle {
    font-size: 1.2rem;
    font-weight: 400;
    color: #f8f8f8;
    max-width: 500px;
  }

  .hero-cta {
    margin-top: 2rem;
  }

  .cta-button {
    padding: 0.75rem 2rem;
    background-color: #fff;
    color: #000;
    border: none;
    font-size: 0.85rem;
    font-weight: 600;
    letter-spacing: 1px;
    cursor: pointer;
    transition: background-color 0.3s ease, color 0.3s ease;
  }

  .cta-button:hover {
    background-color: rgba(255, 255, 255, 0.9);
  }

  /* Responsive Styles */
  @media (max-width: 768px) {
    .nav-container {
      width: 95%;
    }
    
    .nav-links {
      gap: 1.2rem;
    }
    
    .big-text {
      font-size: 3rem;
    }
    
    .subtitle {
      font-size: 1rem;
    }
  }

  @media (max-width: 480px) {
    .nav-logo {
      font-size: 1.2rem;
    }
    
    .nav-links {
      gap: 0.8rem;
    }
    
    .nav-link {
      font-size: 0.75rem;
    }
    
    .big-text {
      font-size: 2.5rem;
    }
    
    .content-wrapper {
      padding: 0 1rem;
    }
    
    .cta-button {
      padding: 0.75rem 1.5rem;
    }

    .password-card {
      padding: 2.5rem;
    }

    .password-title {
      font-size: 1.9rem;
    }
  }
  
  /* Shop Section Styles */
  .about-section {
    padding: 6rem 2rem;
    min-height: 100vh;
    background-color: #f8f8f8;
    color: #000;
  }
  
  .about-container {
    max-width: 1400px;
    margin: 0 auto;
  }
  
  .section-title {
    font-size: 2rem;
    font-weight: 600;
    margin-bottom: 3rem;
    text-align: center;
    letter-spacing: 2px;
  }
  
  .product-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
    gap: 2.5rem;
  }
  
  .product-card {
    background-color: #fff;
    border-radius: 10px;
    overflow: hidden;
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.05);
    transition: transform 0.3s ease, box-shadow 0.3s ease;
  }
  
  .product-card:hover {
    transform: translateY(-5px);
    box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1);
  }
  
  .product-image {
    height: 280px;
    overflow: hidden;
  }
  
  .product-image img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    transition: transform 0.5s ease;
  }
  
  .product-card:hover .product-image img {
    transform: scale(1.05);
  }
  
  .product-info {
    padding: 1.5rem;
  }
  
  .product-title {
    font-size: 1.2rem;
    font-weight: 500;
    margin-bottom: 0.5rem;
  }
  
  .product-price {
    font-size: 1.1rem;
    font-weight: 600;
    color: #333;
    margin-bottom: 1.2rem;
  }
  
  .add-to-cart {
    width: 100%;
    padding: 0.75rem 0;
    background-color: #000;
    color: #fff;
    border: none;
    font-size: 0.9rem;
    font-weight: 500;
    letter-spacing: 1px;
    cursor: pointer;
    transition: background-color 0.3s ease;
  }
  
  .add-to-cart:hover {
    background-color: #333;
  }
  
  @media (max-width: 768px) {
    .product-grid {
      grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
      gap: 1.5rem;
    }
    
    .product-image {
      height: 220px;
    }
    
    .section-title {
      font-size: 1.8rem;
      margin-bottom: 2rem;
    }
  }
  
  @media (max-width: 480px) {
    .about-section {
      padding: 5rem 1rem;
    }
    
    .product-grid {
      grid-template-columns: 1fr;
      gap: 2rem;
    }
    
    .section-title {
      font-size: 1.5rem;
    }
  }

  /* Contact Section Styles */
  .contact-section {
    padding: 6rem 2rem;
    min-height: 100vh;
    background-color: #f8f8f8;
    color: #000;
  }
  
  .contact-container {
    max-width: 1200px;
    margin: 0 auto;
  }
  
  .contact-content {
    display: grid;
    grid-template-columns: 1fr 2fr;
    gap: 3rem;
  }
  
  .contact-info {
    display: flex;
    flex-direction: column;
    gap: 2rem;
  }
  
  .info-item {
    margin-bottom: 1.5rem;
  }
  
  .info-title {
    font-size: 1.1rem;
    font-weight: 600;
    margin-bottom: 0.8rem;
    color: #000;
  }
  
  .info-text {
    font-size: 0.95rem;
    color: #333;
    line-height: 1.6;
  }
  
  .contact-form-container {
    background-color: #fff;
    padding: 2.5rem;
    border-radius: 10px;
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.05);
  }
  
  .contact-form {
    display: flex;
    flex-direction: column;
    gap: 1.5rem;
  }
  
  .form-group {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
  }
  
  .form-group label {
    font-size: 0.9rem;
    font-weight: 500;
    color: #333;
  }
  
  .form-group input,
  .form-group textarea {
    padding: 0.8rem;
    border: 1px solid #ddd;
    border-radius: 5px;
    font-family: inherit;
    font-size: 0.95rem;
    color: #333;
  }
  
  .form-group textarea {
    resize: vertical;
  }
  
  .form-group input:focus,
  .form-group textarea:focus {
    outline: none;
    border-color: #aaa;
  }
  
  .submit-button {
    padding: 0.9rem 0;
    background-color: #000;
    color: #fff;
    border: none;
    border-radius: 5px;
    font-size: 0.9rem;
    font-weight: 500;
    letter-spacing: 1px;
    cursor: pointer;
    transition: background-color 0.3s ease;
    margin-top: 0.5rem;
  }
  
  .submit-button:hover {
    background-color: #333;
  }
  
  @media (max-width: 768px) {
    .contact-content {
      grid-template-columns: 1fr;
      gap: 2rem;
    }
    
    .contact-info {
      order: 2;
    }
    
    .contact-form-container {
      order: 1;
    }
  }

  /* Projects Section Styles */
  .projects-section {
    padding: 6rem 2rem;
    min-height: 100vh;
    background-color: #f8f8f8;
    color: #000;
  }
  
  .projects-container {
    max-width: 1200px;
    margin: 0 auto;
  }
  
  .projects-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(350px, 1fr));
    gap: 2.5rem;
    margin-top: 3rem;
  }
  
  .project-card {
    background-color: white;
    border-radius: 8px;
    overflow: hidden;
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.05);
    transition: transform 0.3s ease, box-shadow 0.3s ease;
  }
  
  .project-card:hover {
    transform: translateY(-10px);
    box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);
  }
  
  .project-image {
    height: 200px;
    overflow: hidden;
  }
  
  .project-image img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    transition: transform 0.5s ease;
  }
  
  .project-card:hover .project-image img {
    transform: scale(1.05);
  }
  
  .project-content {
    padding: 1.5rem;
  }
  
  .project-title {
    font-size: 1.3rem;
    font-weight: 600;
    margin-bottom: 0.75rem;
    color: #222;
  }
  
  .project-description {
    font-size: 0.9rem;
    color: #666;
    margin-bottom: 1.5rem;
    line-height: 1.6;
  }
  
  .project-technologies {
    display: flex;
    flex-wrap: wrap;
    gap: 0.5rem;
    margin-bottom: 1.5rem;
  }
  
  .tech-tag {
    font-size: 0.75rem;
    padding: 0.3rem 0.6rem;
    background-color: #f0f0f0;
    color: #555;
    border-radius: 20px;
  }
  
  .project-links {
    display: flex;
    gap: 1rem;
  }
  
  .project-link {
    color: #333;
    text-decoration: none;
    font-size: 0.9rem;
    font-weight: 500;
    transition: color 0.3s ease;
    position: relative;
  }
  
  .project-link:after {
    content: '';
    position: absolute;
    bottom: -2px;
    left: 0;
    width: 0;
    height: 1px;
    background-color: #333;
    transition: width 0.3s ease;
  }
  
  .project-link:hover {
    color: #000;
  }
  
  .project-link:hover:after {
    width: 100%;
  }
  
  /* Resume Section Styles */
  .resume-section {
    padding: 6rem 2rem;
    min-height: 100vh;
    background-color: #f8f8f8;
    color: #000;
  }
  
  .resume-container {
    max-width: 1000px;
    margin: 0 auto;
  }
  
  .resume-actions {
    display: flex;
    justify-content: center;
    margin-bottom: 3rem;
  }
  
  .download-button {
    padding: 0.8rem 2rem;
    background-color: #333;
    color: white;
    border: none;
    border-radius: 5px;
    font-size: 1rem;
    font-weight: 500;
    cursor: pointer;
    transition: background-color 0.3s ease;
    text-decoration: none;
    display: inline-block;
  }
  
  .download-button:hover {
    background-color: #222;
  }
  
  .resume-preview {
    background-color: white;
    padding: 3rem;
    border-radius: 8px;
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.05);
  }
  
  .resume-header {
    text-align: center;
    margin-bottom: 2rem;
    padding-bottom: 1rem;
    border-bottom: 1px solid #eee;
  }
  
  .resume-name {
    font-size: 1.8rem;
    font-weight: 700;
    margin-bottom: 0.5rem;
    color: #222;
  }
  
  .resume-contact {
    font-size: 0.9rem;
    color: #555;
    line-height: 1.5;
  }
  
  .resume-objective {
    font-size: 0.95rem;
    color: #444;
    margin-bottom: 1rem;
    line-height: 1.6;
  }
  
  .resume-section-content {
    margin-bottom: 3rem;
  }
  
  .resume-section-title {
    font-size: 1.3rem;
    font-weight: 600;
    margin-bottom: 1.5rem;
    padding-bottom: 0.5rem;
    border-bottom: 2px solid #f0f0f0;
    color: #222;
  }
  
  .resume-item {
    margin-bottom: 2rem;
  }
  
  .resume-item-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 0.5rem;
  }
  
  .resume-item-title {
    font-size: 1.1rem;
    font-weight: 600;
    color: #333;
  }
  
  .resume-item-date {
    font-size: 0.9rem;
    color: #777;
  }
  
  .resume-item-subtitle {
    font-size: 1rem;
    color: #555;
    margin-bottom: 0.75rem;
  }
  
  .resume-item-details {
    padding-left: 1.5rem;
    margin: 0.75rem 0;
  }
  
  .resume-item-details li {
    margin-bottom: 0.5rem;
    font-size: 0.9rem;
    color: #666;
  }
  
  .skills-columns {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
    gap: 2rem;
  }
  
  .skills-category {
    font-size: 1rem;
    font-weight: 600;
    margin-bottom: 1rem;
    color: #333;
  }
  
  .skills-list {
    padding-left: 1.5rem;
    margin: 0;
  }
  
  .skills-list li {
    margin-bottom: 0.5rem;
    font-size: 0.9rem;
    color: #666;
  }
  
  /* About Section Updates */
  .about-content {
    background-color: white;
    padding: 3rem;
    border-radius: 8px;
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.05);
    display: flex;
    flex-direction: column;
  }
  
  .about-image-container {
    width: 100%;
    display: flex;
    justify-content: center;
    margin-bottom: 2rem;
  }
  
  .about-image {
    width: 100%;
    max-width: 600px;
    height: auto;
    border-radius: 8px;
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
    object-fit: cover;
  }
  
  .about-text {
    margin-bottom: 3rem;
  }
  
  .bio-text {
    font-size: 1rem;
    color: #555;
    line-height: 1.8;
    margin-bottom: 1.5rem;
  }
  
  .skills-section {
    margin-bottom: 3rem;
  }
  
  .skills-title {
    font-size: 1.3rem;
    font-weight: 600;
    margin-bottom: 1.5rem;
    padding-bottom: 0.5rem;
    border-bottom: 2px solid #f0f0f0;
    color: #222;
  }
  
  .skills-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
    gap: 2rem;
  }
  
  .skill-category {
    margin-bottom: 1.5rem;
  }
  
  .category-title {
    font-size: 1.1rem;
    font-weight: 600;
    margin-bottom: 1rem;
    color: #333;
  }
  
  .skill-list {
    list-style-type: none;
    padding: 0;
  }
  
  .skill-item {
    font-size: 0.9rem;
    color: #555;
    margin-bottom: 0.5rem;
    padding: 0.3rem 0;
  }
  
  .experience-section {
    margin-top: 3rem;
  }
  
  .experience-title {
    font-size: 1.3rem;
    font-weight: 600;
    margin-bottom: 1.5rem;
    padding-bottom: 0.5rem;
    border-bottom: 2px solid #f0f0f0;
    color: #222;
  }
  
  .timeline {
    position: relative;
    padding-left: 2rem;
  }
  
  .timeline:before {
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    height: 100%;
    width: 2px;
    background-color: #f0f0f0;
  }
  
  .timeline-item {
    position: relative;
    padding-bottom: 2.5rem;
  }
  
  .timeline-item:last-child {
    padding-bottom: 0;
  }
  
  .timeline-item:before {
    content: '';
    position: absolute;
    left: -2rem;
    top: 0.3rem;
    width: 12px;
    height: 12px;
    border-radius: 50%;
    background-color: #333;
  }
  
  .timeline-date {
    font-size: 0.9rem;
    color: #777;
    margin-bottom: 0.5rem;
  }
  
  .timeline-content {
    position: relative;
  }
  
  .job-title {
    font-size: 1.1rem;
    font-weight: 600;
    color: #333;
    margin-bottom: 0.5rem;
  }
  
  .job-description {
    font-size: 0.9rem;
    color: #555;
    line-height: 1.6;
  }
  
  /* Social Links */
  .social-links {
    display: flex;
    gap: 1rem;
    margin-top: 0.5rem;
  }
  
  .social-link {
    color: #333;
    text-decoration: none;
    font-size: 0.9rem;
    font-weight: 500;
    transition: color 0.3s ease;
    position: relative;
  }
  
  .social-link:after {
    content: '';
    position: absolute;
    bottom: -2px;
    left: 0;
    width: 0;
    height: 1px;
    background-color: #333;
    transition: width 0.3s ease;
  }
  
  .social-link:hover {
    color: #000;
  }
  
  .social-link:hover:after {
    width: 100%;
  }
  
  /* Responsive Updates */
  @media (max-width: 768px) {
    .projects-grid {
      grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
    }
    
    .resume-preview {
      padding: 2rem;
    }
    
    .skills-columns {
      grid-template-columns: repeat(auto-fill, minmax(160px, 1fr));
    }
    
    .skills-grid {
      grid-template-columns: 1fr;
    }
    
    .timeline {
      padding-left: 1.5rem;
    }
    
    .timeline-item:before {
      left: -1.5rem;
    }
    
    .about-content {
      grid-template-columns: 1fr;
    }
    
    .about-image-container {
      margin-bottom: 2rem;
    }
    
    .about-image {
      max-width: 500px;
    }
  }
  
  @media (max-width: 480px) {
    .projects-grid {
      grid-template-columns: 1fr;
    }
    
    .project-image {
      height: 180px;
    }
    
    .resume-preview {
      padding: 1.5rem;
    }
    
    .resume-item-header {
      flex-direction: column;
      align-items: flex-start;
    }
    
    .resume-item-date {
      margin-top: 0.25rem;
    }
    
    .skills-columns {
      grid-template-columns: 1fr;
    }
    
    .timeline {
      padding-left: 1.25rem;
    }
    
    .timeline-item:before {
      left: -1.25rem;
      width: 10px;
      height: 10px;
    }
    
    .about-image {
      max-width: 400px;
    }
  }
`;
document.head.appendChild(style);
